import { render } from "./AuthPage.vue?vue&type=template&id=f6f615c2&scoped=true"
import script from "./AuthPage.vue?vue&type=script&lang=js"
export * from "./AuthPage.vue?vue&type=script&lang=js"

import "./AuthPage.vue?vue&type=style&index=0&id=f6f615c2&lang=scss&scoped=true"

import exportComponent from "E:\\myProjects\\myPortfolio\\my-portfolio-vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6f615c2"]])

export default __exports__